(ns ui.editors.nev-view-editor.view
  (:require [clojure.string :as string]
            [common.entity :as entity]
            [common.localization :as loc]
            [common.util :as cu]
            [oops.core :as oops]
            [re-frame.core :as rf]
            [ui.components.button.view :as button]
            [ui.components.radix-ui.tooltip.view :as tooltip]
            [ui.components.sortable-list.view :as sortable-list]
            [ui.components.tab-strip.view :as tab-strip]
            [ui.components.toggle.view :as toggle]
            [ui.editors.card.view :as card-editor]
            [ui.editors.labelled-input.view :as labelled-input]
            [ui.editors.nev-view-editor.add-card-wizard :as add-card-wizard]
            [ui.editors.nev-view-editor.event :as event]
            [ui.editors.nev-view-editor.model :as model]
            [ui.editors.nev-view-editor.sub :as sub]
            [ui.editors.nev-view-editor.view-preview :as view-preview]
            [ui.util :as uu]))

(defn full-screen-modal
  [& children]
  [:div
   {:class "fixed z-[200] top-0 left-0 bottom-0 right-0 overflow-y-auto overflow-x-hidden bg-base-light max-w-screen h-screen"}
   (into [:<>] children)])

(defn radio-indicator
  [{:keys [checked?]}]
  [:div
   {:class "flex items-center justify-center rounded-full h-4 w-4 border"}
   [:div
    {:class (uu/cm "h-2 w-2 rounded-full bg-primary-regular hidden"
                   (when checked?
                     "block"))}]])

;; TODO: refactor these to some common namespace
(def access-level-options
  [{:value       :view.access-level/private
    :label       (loc/tr :view-editor/private-access-level)
    :description (loc/tr :view-editor/private-access-level-description)
    :icon-class  "fal fa-lock"}
   {:value       :view.access-level/restricted
    :label       (loc/tr :view-editor/restricted-access-level)
    :description (loc/tr :view-editor/restricted-access-level-description)
    :icon-class  "fal fa-eye"}
   {:value       :view.access-level/all-users
    :label       (loc/tr :view-editor/all-users-access-level)
    :description (loc/tr :view-editor/all-users-access-level-description)
    :icon-class  "fal fa-users"}])

(defn access-level-item
  [{:keys [value set-access-level label description icon-class selected?]}]
  [:div
   {:class    (uu/cm "flex flex-col gap-0 rounded px-4 py-3 ring ring-1 ring-base-light-border-paler transition-colors cursor-pointer hover:ring-base-light-border-accent"
                     (when selected?
                       "ring ring-base-light-border-accent ring-1 ring-inset"))
    :on-click #(set-access-level value)
    :role     :button}
   [:div
    {:class "flex items-start justify-between"}
    [:div
     {:class "flex items-center"}
     [:i {:class (uu/cm icon-class "w-7")}]
     [:p label]]
    [radio-indicator {:checked? selected?}]]
   [:div
    {:class "ml-7"}
    [:p
     {:class "text-sm m-0 text-base-light-text-paler"}
     description]]])

(defn access-level-selector
  []
  (let [access-level @(rf/subscribe [::sub/view-access-level])]
    [:div
     {:class "flex flex-col gap-2"}
     (->> access-level-options
          (map (fn [{:keys [value] :as props}]
                 (let [selected? (= value access-level)]
                   ^{:key (str value)}
                   [access-level-item
                    (assoc props
                           :selected? selected?
                           :set-access-level #(rf/dispatch [::event/set-view-access-level %]))]))))]))

(defn view-sharing-selector
  []
  (let [selected-options @(rf/subscribe [::sub/view-access-teams-and-persons])
        options @(rf/subscribe [::sub/view-access-teams-and-persons-options])
        select-options (->> options
                            (map (fn [opt]
                                   (assoc opt :value (pr-str (:value opt)))))
                            (sort-by :label))]
    [:div
     {:class "flex flex-col gap-5"}
     [labelled-input/view
      {:editor-type :editor.type/select

       :options     select-options
       :value       (->> select-options
                         (cu/filter-by :value options)
                         (first))
       :label       (loc/tr :view-editor/add-people-and-teams)
       :on-change   (fn [e]
                      (let [value-str (uu/evt-target-value e)
                            value (js/parseInt value-str)]
                        (rf/dispatch [::event/add-read-access value])))}]
     ;;  [:div
     ;;   {:class "flex flex-col gap-1"}
     ;;   [:label
     ;;    {:class "text-sm m-0 text-base-light-text-paler"}
     ;;    (loc/tr :view-editor/add-people-and-teams)]
     ;;   [:select
     ;;    {:value "-"
     ;;     :on-change (fn [e]
     ;;                  (let [value-str (.. e -target -value)
     ;;                        value (js/parseInt value-str)]
     ;;                    (rf/dispatch [::event/add-read-access value])))}
     ;;    [:option {:value "-"} "-"]
     ;;    (->> options
     ;;         (map (fn [{:keys [value label]}]
     ;;                ^{:key (str value)}
     ;;                [:option
     ;;                 {:value value}
     ;;                 label])))]
     ;;   ]
     [:div
      {:class "grid grid-cols-7 gap-2"}
      [:div
       {:class "col-span-4 text-sm m-0 text-base-light-text-paler"}
       (loc/tr :view-editor/who-has-access)]
      [:div
       {:class "col-span-3 text-sm m-0 text-base-light-text-paler"}
       (loc/tr :view-editor/permissions)]
      (->> selected-options
           (map (fn [{:keys [value label entity-type owner? read-access? write-access? share-access?]}]
                  (let [entity-id value]
                    ^{:key (str entity-id)}
                    [:<>
                     [:div
                      {:class "col-span-4 flex items-center gap-2"}
                      [:i
                       {:class (uu/cm "w-8 fal" (case entity-type
                                                  :entity.type/account "fa-user"
                                                  :entity.type/team "fa-users"
                                                  ""))}]
                      [:p
                       {:class "pr-5 w-3/4"}
                       label]]
                     [:div
                      {:class "col-span-3 flex items-center gap-2"}
                      (if owner?
                        [:p
                         {:class "text-base-light-text-paler"}
                         (loc/tr :owner)]
                        [:div
                         {:class "flex"}
                         [:select
                          {:class     "p-1 rounded border focus-visible:outline-none focus-visible:ring focus-visible:ring-2 focus-visible:ring-primary-regular"
                           :value     (cond
                                        read-access? :read
                                        write-access? :write
                                        share-access? :share
                                        :else nil)
                           :on-change (fn [e]
                                        (case (uu/evt-target-value e)
                                          "view" (rf/dispatch [::event/add-read-access entity-id])
                                          "write" (rf/dispatch [::event/add-write-access entity-id])
                                          "share" (rf/dispatch [::event/add-share-access entity-id])
                                          (js/console.error "Cannot resolve sharing : " (uu/evt-target-value e))))}
                          [:option
                           {:value :view}
                           (loc/tr :view-editor/read-access)]
                          [:option
                           {:value :write}
                           (loc/tr :view-editor/read-write-access)]]])
                      (when-not owner?
                        [:span
                         [:button
                          {:class    "text-sm m-0 text-base-light-text-paler hover:bg-base-regular rounded"
                           :on-click #(rf/dispatch [::event/remove-access entity-id])}
                          [:i.fal.fa-times]]])]
                     [:div
                      {:class "col-span-7 h-px bg-base-gloomy"}]]))))]]))

(defn tab-selector
  []
  (let [current-tab @(rf/subscribe [::sub/view-editor-tab])
        preview-disabled? false]
    [:div
     {:class "flex justify-center items-center"}
     [tab-strip/view
      {:tabs         [{:value :settings
                       :label [:span
                               {:class "flex gap-2"}
                               [:i {:class "fal fa-cog text-sm m-0"}] (loc/tr :settings)]}
                      {:value :editor
                       :label [:span
                               {:class "flex gap-2"}
                               [:i {:class "fal fa-pencil text-sm m-0"}] (loc/tr :view-editor/edit-view)]}
                      {:value     :preview
                       :disabled? preview-disabled?
                       :label     [:span
                                   {:class "flex gap-2"}
                                   [:i {:class "fal fa-eye text-sm m-0"}] (loc/tr :view-editor/preview-view)]}]
       :selected-tab current-tab
       :on-change!   (fn [value-str]
                       (rf/dispatch-sync [::event/set-view-editor-tab (keyword value-str)]))}]]))

(defn view-editor-header
  []
  (let [{:keys [label disabled? tooltip-label]} @(rf/subscribe [::sub/submit-button-state])
        submit #(rf/dispatch [::event/upsert-view-and-cards])]
    [:div
     {:class "grid grid-cols-4 py-3 px-4 border border-solid border-base-light-border-paler"}
     [:div
      {:class "flex items-center"}
      [:h4
       {:class "font-semibold text-lg"}
       (loc/tr :view-editor/view-settings)]]
     [:div
      {:class "col-span-2"}
      [tab-selector]]
     [:div
      {:class "grow flex gap-2 items-center justify-end"}
      [tooltip/view
       [button/sm-primary-solid
        {:on-click  submit
         :disabled? disabled?}
        label]
       [:span tooltip-label]]
      [button/sm-secondary-hollow
       {:on-click #(rf/dispatch [::event/close-editor])}
       (loc/tr :cancel)]]]))

(defn drag-handle
  [{:keys [size]}]
  (let [size (or size :md)
        container-size (case size
                         :sm 15
                         :md 23
                         :lg 30
                         :xl 40)]
    [:svg {:width (* container-size 0.83) :height (* container-size 1.05)}
     (for [row (range 3)
           col (range 2)]
       ^{:key (str "r" row "c" col)}
       [:circle
        {:cx   (+ (* 0.33 container-size) (* 0.2 container-size col))
         :cy   (+ (* 0.33 container-size) (* 0.2 container-size row))
         :r    (* 0.05 container-size)
         :fill "gray"}])]))

(defn card-component
  [{:keys [card index is-dragging?]}]
  (let [title (:card/title card)
        desc (:card/description card)
        write-access? @(rf/subscribe [::sub/card-write-access? (:db/id card)])
        open-card-editor #(rf/dispatch [::event/open-card-editor {:card card}])
        remove-card #(rf/dispatch [::event/remove-card index])
        can-remove-card? @(rf/subscribe [::sub/can-add-and-remove-cards-from-selected-section?])

        selected-section-title @(rf/subscribe [::sub/selected-section-title])]
    [:div
     {:class "bg-base-light flex items-center justify-between cursor-default p-3 rounded border border-solid border-base-light-border-paler hover:border-base-light-border-accent"}
     [:div
      {:class "flex items-start gap-3"}
      [:div {:class (uu/cm "mt-px cursor-grab bg-complement-regular hover:bg-primary-regular rounded"
                           (when is-dragging?
                             "bg-base-gloomy"))}
       [drag-handle]]
      [:div
       {:class "flex flex-col gap-1"}
       [:p
        {:class "font-semibold text-base-light-text"}
        title]
       [:p {:class "text-base-light-text-paler text-sm m-0"} desc]]]
     [:div
      {:class "flex items-center gap-2"}
      [button/square-secondary-open
       {:on-click  open-card-editor
        :disabled? (not write-access?)
        :tooltip   (if write-access?
                     (loc/tr :view-editor/edit-card)
                     (loc/tr :view-editor/you-dont-have-access-to-edit-this-card))}
       [:i.fal.fa-pencil]]
      [button/square-secondary-open
       {:on-click  remove-card
        :tooltip   (if can-remove-card?
                     (loc/tr :view-editor/remove-card-from-this-view)
                     (str "You cannot remove cards from "
                          (cu/str-trim-lcase selected-section-title)
                          " section"))
        :disabled? (not can-remove-card?)
        :class     "hover:text-danger-regular"}
       [:i.fal.fa-trash]]]]))

(defn sortable-card-list
  []
  (let [cards @(rf/subscribe [::sub/selected-section-cards])]
    [sortable-list/view
     {:items cards
      :get-key :db/id
      :gap 10
      :on-reorder (fn [{:keys [source-index destination-index]}]
                    (rf/dispatch-sync [::event/reorder-cards source-index destination-index]))
      :render-item (fn [{:keys [item index dragging?]}]
                     (let [card item]
                       [:div
                        [card-component
                         {:card card
                          :dragging? dragging?
                          :index index}]]))}]))

(defn view-general-settings
  []
  (let [view-name @(rf/subscribe [::sub/view-name])
        view-description @(rf/subscribe [::sub/view-description])]
    [:div
     {:class "flex flex-col gap-4"}
     [:h4
      {:class "text-base-light-text"}
      (loc/tr :view-editor/general-settings)]
     [:div
      [labelled-input/view
       {:label     (loc/tr :view-editor/view-name)
        :data-type :data.type/text-simple
        :value     view-name
        :on-change #(rf/dispatch-sync [::event/set-view-name %])}]]
     [:div
      [labelled-input/view
       {:label     (loc/tr :view-editor/view-description)
        :data-type :data.type/text-multiline
        :value     view-description
        :on-change #(rf/dispatch-sync [::event/set-view-description %])}]]]))

(defn view-access-settings
  []
  (let [access-level @(rf/subscribe [::sub/view-access-level])
        account-is-view-owner? @(rf/subscribe [::sub/current-account-is-view-owner?])]
    [:div
     {:class "flex flex-col gap-4"}
     [:h4
      {:class "text-base-light-text"}
      (loc/tr :view-editor/view-visibility)]
     (if account-is-view-owner?
       [:<>
        [access-level-selector]
        (when (= access-level :view.access-level/restricted)
          [view-sharing-selector])]
       [:div
        [:p
         {:class "text-sm m-0 text-base-light-text-paler"}
         (loc/tr :view-editor/you-dont-have-access-to-edit-view-visibility)]])]))

(defn delete-view-confirmation-modal
  [{:keys [set-ref close]}]
  [:dialog
   {:ref   set-ref
    :class "border p-0 rounded shadow-md backdrop:bg-secondary-regular backdrop:opacity-30"}
   [:div
    {:class "flex flex-col gap-4 p-4 w-80"}
    [:div
     [:div
      {:class "relative flex justify-center mb-2"}
      [:i.fal.fa-exclamation-triangle
       {:class "text-danger text-2xl"}]
      [:div
       {:class "absolute -top-2 -right-2"}
       [button/square-secondary-open
        {:class    "text-sm text-base-light-text-paler m-0"
         :on-click close}
        [:i.fal.fa-times]]]]
     [:h4
      {:class "text-lg text-center"}
      (loc/tr :view-editor/delete-view)]
     [:p
      {:class "text-sm m-0 text-base-light-text-paler text-center"}
      (loc/tr :delete-entity-confirmation [(-> :entity.type/view
                                               (loc/tr)
                                               (string/lower-case))])]]
    [:div
     {:class "flex flex justify-center gap-2"}
     [button/sm-secondary-hollow
      {:on-click close}
      (loc/tr :cancel)]
     [button/sm-danger-solid
      {:class    ""
       :on-click #(rf/dispatch [::event/disable-view])}
      (loc/tr :delete)]]]])

(defn delete-view-settings
  []
  (let [modal-ref (atom nil)
        show-modal #(when-let [modal @modal-ref]
                      (oops/ocall modal "showModal"))
        close-modal #(when-let [modal @modal-ref]
                       (oops/ocall modal "close"))]
    (fn []
      (let [is-owner? @(rf/subscribe [::sub/current-account-is-view-owner?])
            create-new-view? @(rf/subscribe [::sub/create-new-view?])
            clone-view? @(rf/subscribe [::sub/clone-view?])]
        (when-not (or create-new-view? clone-view?)
          [:<>
           [:div
            {:class "flex flex-col gap-4"}
            [:h4
             {:class "text-base-light-text text-danger-regular"}
             (loc/tr :view-editor/danger-zone)]
            [:div
             {:class "flex flex-col items-start gap-1"}
             [button/sm-danger-solid
              {:class     ""
               :disabled? (not is-owner?)
               :on-click  show-modal}
              (loc/tr :view-editor/delete-view)]
             (when-not is-owner?
               [:div
                [:p
                 {:class "text-sm text-base-light-text-paler m-0"}
                 (loc/tr :view-editor/only-view-owner-can-delete-view)]])]]
           [delete-view-confirmation-modal
            {:set-ref #(reset! modal-ref %)
             :close   close-modal}]])))))

(defn view-settings
  []
  [:div
   {:class "w-full max-w-full p-5 flex flex-col items-center h-full max-h-full overflow-hidden overflow-y-auto pb-72"}
   [:div
    {:class "flex flex-col gap-10 w-xl max-w-full"}
    [view-general-settings]
    [view-access-settings]
    [delete-view-settings]]])

(defn section-item
  [{:keys [id title description icon-class
           always-visible?
           on-select selected?
           hidden? toggle-hidden]}]
  (let []
    [:div
     {:on-click on-select
      :class    (uu/cm " pl-5 pr-5 py-3 flex items-start gap-3 cursor-default hover:bg-primary-light"
                       (when selected?
                         "bg-primary-light"))}
     [:div
      {:class "w-7 h-7 flex justify-center items-center shrink-0 bg-complement-regular rounded"}
      [:i {:class (uu/cm icon-class)}]]
     [:div
      {:class "grow"}
      [:div
       {:class "flex justify-between"}
       [:p
        {:class "font-semibold"}
        title]
       [:div
        {:class    "px-2 flex items-center gap-1"
         :on-click (fn [e]
                     (oops/ocall e "stopPropagation"))}]]

      (when description
        [:p
         {:class "text-sm m-0 text-base-light-text-paler"}
         description])]

     [:div
      {:class    "shrink-0 ml-3"
       :on-click (fn [e]
                   (oops/ocall e "stopPropagation"))}
      [:div
       {:class "flex items-center gap-1"}
       ;;  [:label
       ;;   {:for (str "section-hidden-" id)
       ;;    :class "text-sm m-0 font-medium text-base-light-text-paler"}
       ;;   (loc/tr :visible-lc)]
       [toggle/toggle
        {:id        (str "section-hidden-" id)
         :checked?  (not hidden?)
         :disabled? always-visible?
         :on-change toggle-hidden}]]]]))

;; TODO: Figure out the right name - sidebar settings, sidebar content?
(defn sections-view
  []
  (let [sections @(rf/subscribe [::sub/sections])
        selected-section @(rf/subscribe [::sub/selected-section])
        hidden-sections-set @(rf/subscribe [::sub/hidden-sections])]
    [:div
     {:class "flex flex-col items-stretch"}
     (->> sections
          (map (fn [{:keys [id] :as section}]
                 (let [selected? (= id selected-section)
                       hidden? (hidden-sections-set id)]
                   ^{:key (str id)}
                   [section-item
                    (assoc section
                           :hidden? hidden?
                           :selected? selected?
                           :on-select #(rf/dispatch [::event/set-selected-section id])
                           :toggle-hidden #(rf/dispatch [::event/toggle-section-hidden id]))])))
          (doall))]))

(defn top-level-sections-view
  []
  (let [selected-top-level-section @(rf/subscribe [::sub/selected-top-level-section])
        hidden-top-level-sections-set @(rf/subscribe [::sub/hidden-top-level-sections])
        primary-entity-type @(rf/subscribe [::sub/primary-entity-type])
        linked-entity-sections @(rf/subscribe [::sub/available-linked-entity-sections])
        set-selected-top-level-section #(rf/dispatch [::event/set-selected-top-level-section %])
        toggle-hidden #(rf/dispatch [::event/toggle-top-level-section-hidden %])]
    [:div
     {:class "flex flex-col"}
     [section-item
      {:id                 :primary-entity
       :title              (loc/tr primary-entity-type)
       :selected?          (= selected-top-level-section :primary-entity)
       :description        (-> primary-entity-type
                               loc/tr
                               (str " insights"))
       :top-level-section? true
       :always-visible?    true
       :on-select          #(set-selected-top-level-section :primary-entity)
       :icon-class         (str "fal " (-> {:entity/type primary-entity-type}
                                           entity/default-icon
                                           cu/kw->str))}]
     [sortable-list/view
      {:items linked-entity-sections
       :get-key :id
       :on-reorder (fn [{:keys [source-index destination-index]}]
                     (rf/dispatch-sync [::event/reorder-top-level-sections source-index destination-index]))
       :drop-indicator-type :terminal-no-bleed
       :render-item (fn [{:keys [item]}]
                      (let [section item
                            id (:id section)
                            selected? (= id selected-top-level-section)
                            hidden? (hidden-top-level-sections-set id)]
                        [section-item
                         (assoc section
                                :hidden? hidden?
                                :selected? selected?
                                :on-select #(set-selected-top-level-section id)
                                :toggle-hidden #(toggle-hidden id))]))}]]))

(defn content-header
  []
  (let [selected-section-title @(rf/subscribe [::sub/selected-section-title])
        can-add-cards? @(rf/subscribe [::sub/can-add-and-remove-cards-from-selected-section?])]
    [:div
     {:class "flex justify-between items-center"}
     [:h4
      {:class "text-lg font-bold"}
      (str selected-section-title " content")
      #_(loc/tr :view-editor/view-content)]
     [:div
      [button/sm-primary-solid
       {:on-click  #(rf/dispatch [::event/open-add-card-wizard])
        ;; TODO add translation
        :tooltip   (when-not can-add-cards?
                     (str "You cannot add cards to the "
                          (cu/str-trim-lcase selected-section-title)
                          " section"))
        :disabled? (not can-add-cards?)}
       [:i.fal.fa-plus]
       (loc/tr :add-card)]]]))


;; TODO: make the no module access and not available in nev 2024 views more appealing
;; add localization after copy finalized
(defn no-module-access-view
  []
  (let []
    [:div
     {:class "w-full h-full flex flex-col justify-center items-center"}
     [:p "You don't have access to this module."]
     [:p "Please request access from your administrator."]]))

;; TODO: add localization after copy finalized
(defn not-available-in-nev-2024-view
  []
  (let [selected-section-title @(rf/subscribe [::sub/selected-section-title])]
    [:div
     {:class "w-full h-full flex flex-col justify-center items-center text-center"}
     [:p (str selected-section-title " not yet available in new entity viewer.")]
     [:p "Please switch to classic view mode to see the information."]]))

(defn view-editor-content
  []
  (let [no-module-access? @(rf/subscribe [::sub/no-module-access-to-selected-section?])
        not-available-in-nev-2024? @(rf/subscribe [::sub/selected-section-not-available-in-nev-2024?])]
    (cond
      no-module-access?
      [no-module-access-view]

      not-available-in-nev-2024?
      [not-available-in-nev-2024-view]

      :else
      [:div
       {:class "flex flex-col gap-4"}
       [:div
        {:class "px-4 pt-4"}
        [content-header]]
       [:div
        {:class "px-4 pb-4"}
        [sortable-card-list]]])))

(defn view-editor-edit-tab
  []
  [:div
   {:class "flex h-full max-h-full items-stretch w-screen max-w-screen overflow-hidden"}
   [:div
    {:class "w-1/3 border border-y-0 border-l-0 max-h-full overflow-hidden overflow-y-auto"}
    [top-level-sections-view]]
   [:div
    {:class "w-1/3 border border-y-0 border-l-0 max-h-full overflow-hidden overflow-y-auto"}
    [sections-view]]
   [:div
    {:class "w-1/3 flex flex-col gap-3 bg-complement-light max-h-full overflow-hidden overflow-y-auto"}
    [view-editor-content]]])


(defn view-editor
  [{:keys [render-preview]}]
  (let [view-editor-tab @(rf/subscribe [::sub/view-editor-tab])]
    [:div
     {:class "flex flex-col w-screen h-screen overflow-hidden"}
     [view-editor-header]
     [:div
      {:class "grow overflow-hidden"}
      (case view-editor-tab
        :editor [view-editor-edit-tab]
        :settings [view-settings]
        :preview [view-preview/view
                  {:render-preview (fn []
                                     (render-preview
                                      {:state-path    model/preview-state-full-path
                                       :preview-mode? true}))}])]]))

(defn content
  [props]
  (let [location @(rf/subscribe [::sub/location])]
    (case location
      :view-editor [view-editor props]
      :add-card-wizard [add-card-wizard/view]
      :card-editor [card-editor/view])))

(defn view
  [props]
  (let [visible? @(rf/subscribe [::sub/visible?])
        _ @(rf/subscribe [::sub/unsaved-changes-confirm])]
    (when visible?
      [full-screen-modal
       [content props]])))
